<template>
    <div class="erpmocui13">
        <div class="search-bar">
            <div class="row align-items-center">
                <label class="col">
                    <span>開始</span>
                    <input 
                        min="2009-01-01"
                        max="9999-12-31"
                        type="date"
                    />
                </label>
                <label class="col">
                    <span>結束</span>
                    <input
                        min="2009-01-01"
                        max="9999-12-31"
                        type="date"
                    />
                </label>
            </div>
            <div class="row align-items-center">
                <div class="col-4 p-0">
                    <select class="w-100">
                        <option>請選擇</option>
                    </select>
                </div>
                <div class="col-8 text-align-end"
                    style="text-align: end;"
                >
                    <input class="w-75" type="text">
                    <button>搜尋</button>
                </div>
            </div>
            <div class="row align-items-center justify-content-end">
                <div class="col-3">
                    <button>
                        清單檢視
                    </button>
                </div>
                <div class="col-3">
                    <button>
                        進階搜尋
                    </button>
                </div>
            </div>
        </div>
        <!-- <CourseCircle color="blue"/>
        <CourseCircle color="red"/>
        <CourseCircle color="yellow"/>
        <CourseCircle color="green"/>
        <CourseCircle color="white"/> -->
        <OrderCard 
            color="blue"
            :body_content="body_content"
        />
        <OrderCard
            color="yellow"
            :body_content="body_content"
        />
        <OrderCard
            color="green"
            :body_content="body_content"
        />
        <OrderCard 
            color="blue"
            :body_content="body_content"
        />
        <OrderCard 
            color="blue"
            :body_content="body_content"
        />
        <OrderCard 
            color="blue"
            :body_content="body_content"
        />
        <OrderCard 
            color="blue"
            :body_content="body_content"
        />
    </div>
</template>
<script>
import CourseCircle from './components/CourseCircle.vue'
import OrderCard from './components/OrderCard.vue'
import { BButton, BRow, BCol, BFormInput, BFormGroup, BFormDatepicker } from 'bootstrap-vue'
import { onMounted, reactive, ref } from '@vue/composition-api'
export default {
    name: 'ERPMOCUI13',
    components: {
        BButton,
        BRow,
        BCol,
        BFormInput,
        BFormGroup,
        CourseCircle,
        OrderCard,
        BFormDatepicker,
    },
    setup(props, ctx) {
        const total_order = ref(10)
        onMounted(()=>{
            let tar = document.querySelector('.btn-scroll-to-top')
            if(tar){
                tar.remove()
            }
        })

        const body_content = [{
                title: '訂單',
                content: '2201-0980114005-0001'
            },
            {
                title: '客戶',
                content: '一沐日 EMoz'
            },
            {
                title: '品號',
                content: '10420110902127001'
            },
            {
                title: '品名',
                content: '烏龍綠 + 粉桂'
            },
            {
                title: '規格',
                content: '無糖微冰'
            },
            {
                title: '數量',
                content: '1000 杯'
            },
            {
                title: '單身備註',
                content: '11點前送達'
            },
            {
                title: '單頭備註',
                content: '每天都要送'
            },
            {
                title: '客戶單號',
                content: '4500197562'
            },
            {
                title: '客戶品號',
                content: '6414479'
            },
            {
                title: '訂單狀態',
                content: 'Y: 自動結案'
            }]

        return {
            body_content
        }
    }
}
</script>
<style lang="scss">
.search-bar {
    .row, .col, .col-3 {
        width: 100%;
        margin: 0px;
        padding: 0px;
    }

    .row {
        margin: 5px 0 0 0;
    }

    background-color: #f3f0f0;
    border-radius: 2px;
    padding: 5px 5px 5px 5px;
    width: 340px;
    span {
        width: 20%;
        margin-right: 10px;
    }

    label {
        width: 50%;
        color: #000;
    }

    select {
        outline-style: none;
        border: none;
    }

    input {
        outline-style: none;
        border: none;
        background-color: #fff;
        width: 70%;
    }

    button {
        outline-style: none;
        border: none;
        background-color: #dbdbdb;
    }
    
    > div {
        margin-bottom: 5px;
    }
}
</style>
  